document.addEventListener("DOMContentLoaded", function () {
    // Check if screen width is 768px or less
    if (window.matchMedia("(max-width: 768px)").matches) {
        // Select the Treatments main item
        const treatmentsMainItem = document.querySelector(".treatments-l");
        const subTreatmentItems = document.querySelectorAll(".sub-treatments-title");

        // Toggle function to handle opening and closing
        function toggleDisplay(element, expandedClass) {
            if (element.style.display === "block") {
                element.style.display = "none";
                element.parentElement.classList.remove(expandedClass);
            } else {
                element.style.display = "block";
                element.parentElement.classList.add(expandedClass);
            }
        }

        // Event listener for the main Treatments item
        treatmentsMainItem.addEventListener("click", function (event) {
            event.preventDefault();
            const subNav = treatmentsMainItem.querySelector(".sub-nav");
            toggleDisplay(subNav, "expanded");
        });

        // Event listeners for each sub-treatment category
        subTreatmentItems.forEach(item => {
            item.addEventListener("click", function (event) {
                event.preventDefault();
                const sublist = this.querySelector(".treatments-sub-nav");
                toggleDisplay(sublist, "expanded");
            });

            // Stop propagation on clicks within each sub-treatment list
            const subItems = item.querySelectorAll(".treatments-sub-nav li");
            subItems.forEach(subItem => {
                subItem.addEventListener("click", function (event) {
                    event.stopPropagation();
                });
            });
        });

        // Stop propagation for the items inside .sub-nav to avoid closing
        const subNavItems = treatmentsMainItem.querySelectorAll(".sub-nav li");
        subNavItems.forEach(item => {
            item.addEventListener("click", function (event) {
                event.stopPropagation();
            });
        });
    }
});
document.addEventListener("DOMContentLoaded", function () {
    const hamburgerContainer = document.querySelector(".hamburger-container");
    const hamburgerIcon = document.getElementById("hamburger-icon");
    const navElement = document.querySelector("nav");
    const mainNav = document.querySelector(".main-nav");

    hamburgerContainer.addEventListener("click", function () {
        hamburgerIcon.classList.toggle("open"); // Toggle the 'open' class on the child element
        navElement.classList.toggle("nav-open");
    });
    mainNav.addEventListener("click", function(event) {
        event.stopPropagation();
    });
});